/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { PageTitle } from '../../../_metronic/layout/core'
import { EngageChart } from './components/EngageChart'
import { UsersCard } from './components/UsersCard'
import { GetPlanilhaClaudia } from './core/_requests'

const DashboardPage: FC = () => {
  const [isExporting, setIsExporting] = useState(false)

  const handleExportPlanilhaClaudia = async () => {
    try {
      setIsExporting(true)
      const response = await GetPlanilhaClaudia()

      const blobUrl = window.URL.createObjectURL(new Blob([response.data]))
      
      let filename = 'Planilha-Pacientes.xlsx'
      const disposition = response.headers['content-disposition']
      
      if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(disposition)
        if (matches != null && matches[1]) { 
          filename = matches[1].replace(/['"]/g, '')
        }
      }

      const link = document.createElement('a')
      link.href = blobUrl
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Erro ao fazer o download da planilha:', error)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <>
      <div className='d-flex justify-content-end mb-5'>
        <button 
          className='btn btn-success' 
          onClick={handleExportPlanilhaClaudia}
          disabled={isExporting}
        >
          {isExporting ? (
            <>
              <span className='spinner-border spinner-border-sm me-2' role='status' />
              Baixando...
            </>
          ) : (
            'Planilha da Cláudia'
          )}
        </button>
      </div>

      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {/* begin::Col */}
        <div className='col-md-12 col-lg-12 col-xl-12 col-xxl-3' style={{ display: 'flex', flexDirection: 'column', gap: 20, justifyContent: 'space-between' }}>
        <UsersCard
          className=''
          description='Vídeos totais'
          color='#F1416C'
          img={toAbsoluteUrl('/media/patterns/vector-1.png')}
        />
      </div>
      {/* end::Col */}

      {/* begin::Col */}

      {/* end::Col */}

      {/* begin::Col */}
      <div className='col-xxl-9'>
        <EngageChart className='h-md-100' />
      </div>
      {/* end::Col */}
    </div>
    {/* end::Row */}

    {/* begin::Row */}
    <div className='row gx-5 gx-xl-10'>
      {/* begin::Col */}
      <div className='col-xxl-6 mb-5 mb-xl-10'>
        {/* <app-new-charts-widget8 cssclassName="h-xl-100" chartHeight="275px" [chartHeightNumber]="275"></app-new-charts-widget8> */}
      </div>
      {/* end::Col */}

      {/* begin::Col */}
      <div className='col-xxl-6 mb-5 mb-xl-10'>
        {/* <app-cards-widget18 cssclassName="h-xl-100" image="./assets/media/stock/600x600/img-65.jpg"></app-cards-widget18> */}
      </div>
      {/* end::Col */}
    </div>
    {/* end::Row */}

  </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
